export const CONFIRMED = "confirmed"
export const REQUIRED = "Field is required"
export const PHONE = "phone"
export const EMAIL = "email"
export const EMAIL_ERROR = "Enter a valid email address"
export const PHONE_ERROR = "Please enter valid Number. Eg: +919814253640"
export const LINK = "link"
export const LINK_ERROR = "Link is not valid"
